import { toast } from 'react-toastify';
import Button from '@/components/Button';
import { useUserContext } from '@/contexts/UserContext';
import UserInfoLayout from '@/pages/front-office/me/UserInfoLayout';
import { useState } from 'react';
import { emptyStorage } from '@/utils/emptyStorage';

const EditUserInfo = () => {
	const { user } = useUserContext();
	const [data, setData] = useState({
		last_name: user?.last_name || '',
		first_name: user?.first_name || '',
		email: user?.email || '',
		password: '',
		phone_number: user?.phone_number || '',
		confirm_password: '',
	});

	const handleSubmit = async (event) => {
		event.preventDefault();
		const formData = new FormData(event.target);
		const pwd = formData.get('password');
		const cpwd = formData.get('confirm_password');

		if (pwd.toLowerCase() !== cpwd.toLowerCase()) {
			toast.info('Les mots de passes doivent être identiques', {
				position: 'top-center',
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				theme: 'colored',
				progress: undefined,
			});

			return;
		}

		try {
			const data = {
				last_name: formData.get('last_name') || undefined,
				first_name: formData.get('first_name') || undefined,
				email: formData.get('email') || undefined,
				password: pwd || undefined,
				confirm_password: cpwd || undefined,
			};

			const response = await axios.put(`/api/me/${user.email}/update`, data);

			if (response.status === 200) {
				toast.success('Utilisateur modifié avec succès, veuillez vous reconnecter', {
					position: 'top-center',
					autoClose: 1400,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: false,
					draggable: true,
					theme: 'colored',
					progress: undefined,
				});

				emptyStorage();
			}
		} catch (error) {
			console.error('Error:', error);

			toast.error('Une erreur est survenue', {
				position: 'top-center',
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				theme: 'colored',
				progress: undefined,
			});
		}

		setTimeout(() => window.location.reload(), 1000);
	};

	return (
		<UserInfoLayout>
			<form onSubmit={handleSubmit}>
				<div className="grid grid-cols-2 gap-4 mb-4">
					<div className="flex flex-col text-left">
						<label htmlFor="last_name" className="pl-2">
							Nom
						</label>
						<input
							type="text"
							id="last_name"
							name="last_name"
							className="p-2 rounded-lg"
							value={data.last_name}
							onChange={(e) => setData({ ...data, last_name: e.target.value })}
						/>
					</div>

					<div className="flex flex-col text-left">
						<label htmlFor="first_name" className="pl-2">
							Prénom
						</label>
						<input
							type="text"
							id="first_name"
							name="first_name"
							className="p-2 rounded-lg"
							value={data.first_name}
							onChange={(e) => setData({ ...data, first_name: e.target.value })}
						/>
					</div>
				</div>
				<div className="flex flex-col mb-4 text-left">
					<label htmlFor="email" className="pl-2">
						Email
					</label>
					<input
						type="email"
						id="email"
						name="email"
						className="p-2 rounded-lg"
						value={data.email}
						onChange={(e) => setData({ ...data, email: e.target.value })}
					/>
				</div>
				<div className="grid grid-cols-1 md:grid-cols-2 mb-4 gap-4">
					<div className="flex flex-col text-left">
						<label htmlFor="password" className="pl-2">
							Mot de passe
						</label>
						<input
							type="password"
							id="password"
							name="password"
							className="p-2 rounded-lg"
							value={data?.password}
							onChange={(e) => setData({ ...data, password: e.target.value })}
						/>
					</div>

					<div className="flex flex-col mb-4 text-left">
						<label htmlFor="confirm_password" className="pl-2">
							Confirmer le mot de passe
						</label>
						<input
							type="password"
							id="confirm_password"
							name="confirm_password"
							className="p-2 rounded-lg"
							value={data?.confirm_password}
							onChange={(e) => setData({ ...data, confirm_password: e.target.value })}
						/>
					</div>
				</div>
				<div className="flex flex-col mb-4 text-left">
					<label htmlFor="phoneNumber">Numéro de téléphone</label>
					<input
						type="text"
						id="phoneNumber"
						name="phoneNumber"
						className="p-2 rounded-lg"
						value={data.phone_number}
						onChange={(e) => setData({ ...data, phone_number: e.target.value })}
					/>
				</div>
				<Button action="submit" text={'Modifier mes informations'} handleSubmit={handleSubmit} disabled={true} />{' '}
				{/* disabled => false */}
			</form>
		</UserInfoLayout>
	);
};

export default EditUserInfo;
